// Nuffies pack picker (blocks/nuffies-bundle-picker.liquid).
// 1 towel: the theme's normal add to cart (quantity kept at 1).
// 2 or 3 towels: this towel plus the designs picked on the picture tiles are added in one go, then the cart drawer opens.
// The Lot: one of every design (this towel + the three others, listed in data-lot-ids). Nothing to pick: the
// design tiles are swapped for a view of the four towels they're getting, and all four are added in one go.
// The price under the title and the sticky add-to-cart bar follow the selected pack (window.__nbpSetPrice, inline in the block).
// The submit is caught on window (capture) so it runs before the theme's own form handler.
import { CartLinesUpdateEvent } from '@shopify/events';

(() => {
  const root = document.querySelector('[data-nbp]');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = '1';

  const form = document.getElementById(root.dataset.formId);
  const designs = root.querySelector('[data-nbp-designs]');
  const slot3 = root.querySelector('[data-nbp-slot="3"]');
  const lotView = root.querySelector('[data-nbp-lotview]');
  const errorEl = root.querySelector('[data-nbp-error]');
  const qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
  const lotIds = (root.dataset.lotIds || '').split(',').filter(Boolean);

  // The pack choice replaces the quantity box on towel pages.
  if (qtyInput) {
    const wrap = qtyInput.closest('.quantity-selector-wrapper') || qtyInput;
    wrap.style.display = 'none';
  }

  const selected = () => Number(root.querySelector('.nbp__radio:checked')?.value || 1);

  const pickedIds = (n) => {
    const ids = [String(root.dataset.variantId)];
    if (n === 4) return ids.concat(lotIds);
    for (let slot = 2; slot <= n; slot += 1) {
      const picked = root.querySelector(`[data-nbp-slot="${slot}"] [data-nbp-pick]:checked`);
      if (picked) ids.push(String(picked.value));
    }
    return ids;
  };

  const setPrice = () => {
    if (typeof window.__nbpSetPrice !== 'function') return;
    window.__nbpSetPrice(selected());
  };

  // Picture tiles: highlight the picked towel in each slot and show its name next to the slot number.
  const syncTiles = () => {
    root.querySelectorAll('[data-nbp-slot]').forEach((slotEl) => {
      let name = '';
      slotEl.querySelectorAll('.nbp__tile').forEach((tile) => {
        const input = tile.querySelector('[data-nbp-pick]');
        const picked = Boolean(input && input.checked);
        tile.classList.toggle('is-picked', picked);
        if (picked) name = input.dataset.name || '';
      });
      const label = slotEl.querySelector('[data-nbp-slotname]');
      if (label && name) label.textContent = name;
    });
  };

  const update = () => {
    const n = selected();
    root.querySelectorAll('.nbp__opt').forEach((opt) => {
      opt.classList.toggle('is-selected', opt.querySelector('.nbp__radio').checked);
    });
    designs.hidden = n < 2 || n === 4;
    if (slot3) slot3.hidden = n < 3;
    if (lotView) lotView.hidden = n !== 4;
    if (qtyInput) qtyInput.value = 1;
    errorEl.hidden = true;
    syncTiles();
    setPrice();
  };

  root.querySelectorAll('.nbp__radio').forEach((radio) => radio.addEventListener('change', update));
  root.querySelectorAll('[data-nbp-pick]').forEach((pick) =>
    pick.addEventListener('change', () => {
      errorEl.hidden = true;
      syncTiles();
      setPrice();
    })
  );
  update();

  let busy = false;

  window.addEventListener(
    'submit',
    async (event) => {
      if (!form || event.target !== form) return;
      const n = selected();
      if (n < 2) {
        if (qtyInput) qtyInput.value = 1;
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      busy = true;
      errorEl.hidden = true;

      const ids = pickedIds(n);

      const counts = {};
      ids.forEach((id) => {
        counts[id] = (counts[id] || 0) + 1;
      });
      const items = Object.entries(counts).map(([id, quantity]) => ({ id: Number(id), quantity }));

      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : null))
        .filter(Boolean);

      const deferred = CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
          promise: deferred.promise,
        })
      );

      try {
        const addResponse = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items,
            sections: sectionIds.join(','),
            sections_url: window.location.pathname,
          }),
        }).then((r) => r.json());

        const cart = await fetch(`${Theme.routes.cart_url}.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        }).then((r) => r.json());

        if (addResponse.status) {
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { didError: true, items: cart.items, source: 'nuffies-pack', itemCount: 0 },
          });
          errorEl.textContent =
            addResponse.description || "Sorry, we can't add that pack right now. Try different designs.";
          errorEl.hidden = false;
          return;
        }

        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            source: 'nuffies-pack',
            itemCount: ids.length,
            sections: addResponse.sections,
            didError: false,
          },
        });

        const drawer = document.getElementById('cart-drawer');
        if (drawer && !drawer.isOpen && typeof drawer.open === 'function') drawer.open();
      } catch (error) {
        deferred.reject(error);
        window.location.reload();
      } finally {
        busy = false;
      }
    },
    true
  );
})();
